import React from 'react';

const SvgBell = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 2a1.5 1.5 0 00-1.5 1.5v.695A5.998 5.998 0 006 10v6l-2 2v1h16v-1l-2-2v-6a5.995 5.995 0 00-4.5-5.803V3.5A1.5 1.5 0 0012 2zm-2 18a2 2 0 004 0h-4z" />
  </svg>
);

export default SvgBell;
